<section id="challenge" class="relative scroll-mt-28 overflow-hidden border-t border-surface">
    <app-landing-glow [variant]="1" />
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="max-w-3xl">
            <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().challengeTitle }}</div>
            <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().challengeSubtitle }}</h2>
        </div>

        <div class="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            @for (card of text().challengeCards; track card.title; let i = $index) {
                <article [appRevealOnScroll]="i * 90" class="rounded-3xl border border-surface bg-surface-0 p-6 shadow-lg shadow-black/10 dark:bg-white/5">
                    <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-yellow-500/10 text-xl text-yellow-500">
                        <i [class]="'pi ' + challengeIcons[i]"></i>
                    </div>
                    <h3 class="mt-5 text-xl font-semibold text-surface-900 dark:text-white">{{ card.title }}</h3>
                    <p class="mt-3 leading-7 text-muted-color">{{ card.description }}</p>
                </article>
            }
        </div>
    </div>
</section>
